module.exports = __webpack_public_path__ + "img/search-pvt-chart.81a521c3.jpg";